/*
Fasteners

  --type <string::enum> | ['Bed Rail', 'Biscuit', 'Keyhole', 'Clips', 'Tite Joint']
  --pair <boolean::switch> | ['Pair', 'Individual']
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Fasteners'
const id = 'Y92SvmoOkQFtNtmxMsBR'

export default {
  name,
  id,
  filters,
  headers,
  form
}
